export const getAcademicSessionStartYear = (sessionYear) => {
  const match = String(sessionYear || "").match(/^(\d{4})\s*\/\s*(\d{4})$/);
  return match ? Number(match[1]) : Number.NEGATIVE_INFINITY;
};

export const sortAcademicSessionsDescending = (sessions = []) =>
  [...sessions].sort((left, right) => {
    const yearDifference =
      getAcademicSessionStartYear(right.sessionYear) -
      getAcademicSessionStartYear(left.sessionYear);
    if (yearDifference) return yearDifference;
    return String(right.sessionYear || "").localeCompare(
      String(left.sessionYear || "")
    );
  });

export const getMostRecentAcademicSession = (sessions = []) =>
  sortAcademicSessionsDescending(sessions)[0] || null;
